module.exports = __webpack_public_path__ + "img/logo.e1cbace0.svg";